import React from "react";
import {useTypedSelector} from "../../../../hooks/useTypedSelector";

function Champions() {

    const {user} = useTypedSelector(state => state.auth);

    let rankPopupTextContainerClass = '';
    if (user.rank_champions.length <= 0) {
        rankPopupTextContainerClass = ' rankPopupTextContainerCustom';
    }

    return <div className={'rankPopup'}>

        <div className={'rankPopupTitle'}>
            <div className={'rankPopupTitleText'}>Champions</div>
        </div>

        <div className={'rankPopupTextContainer' + rankPopupTextContainerClass}>
            {(user.rank_champions.length > 0) ?
                <div></div>
                : <div className={'rankNoChampion'}>In this season, no one has become the champion yet.
                    <br/>Try your luck and skill!</div>
            }
            {Object.keys(user.rank_champions).map((item, index) => {
                return <div key={'rank_' + item}
                            className={'rankChampionPosition'}>{parseInt(item) + 1}. {user.rank_champions[item]}</div>;
            })}


        </div>
    </div>
}

export default Champions;